import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

function getOrCreateSessionId() {
    try {
        let sid = window.localStorage.getItem("g2b_session_id");
        if (!sid) {
            sid = crypto.randomUUID
                ? crypto.randomUUID()
                : `s-${Date.now()}-${Math.random().toString(36).slice(2)}`;
            window.localStorage.setItem("g2b_session_id", sid);
        }
        return sid;
    } catch (e) {
        return `s-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    }
}

/** Pings /api/visit on mount and every 60s while the page is open. */
export function useVisitTracker() {
    const startedRef = useRef(false);
    useEffect(() => {
        if (startedRef.current) return;
        startedRef.current = true;
        const sid = getOrCreateSessionId();
        const ping = () => {
            api.post("/visit", { session_id: sid, path: window.location.pathname }).catch(() => {});
        };
        ping();
        const id = setInterval(ping, 60_000);
        return () => clearInterval(id);
    }, []);
}

/** Polls /api/live-stats. */
export function useLiveStats(pollMs = 15000) {
    const [stats, setStats] = useState(null);
    useEffect(() => {
        let cancelled = false;
        const fetchOnce = async () => {
            try {
                const { data } = await api.get("/live-stats");
                if (!cancelled) setStats(data);
            } catch (e) {
                /* noop */
            }
        };
        fetchOnce();
        const id = setInterval(fetchOnce, pollMs);
        return () => {
            cancelled = true;
            clearInterval(id);
        };
    }, [pollMs]);
    return stats;
}
